import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WidgetLayoutService } from './widget-layout.service';
import { FiWidgetIconComponent } from './icon/icon.component';
import { FiFormatDateModule } from '../fi-format-date/fi-format-date.module';
import { WidgetSharedService } from '@fi-shared/widget/widget-shared.service';

@NgModule({
    imports: [CommonModule, FiFormatDateModule],
    declarations: [FiWidgetIconComponent],
    exports: [FiWidgetIconComponent, FiFormatDateModule],
    providers: [WidgetLayoutService, WidgetSharedService],
})
export class FiSharedWidgetModule {}
